const MenuPartItemType = {
  CATEGORY: 0,

  // no 1, we want to correspond to the ItemType

  PRODUCT: 2,
};

export default MenuPartItemType;
